module.exports = __webpack_public_path__ + "img/pmark.b60a5ca6.png";